import styled from "styled-components";
import { TextFont, Colors } from "../../config";
const pdfIcon = require("../../assets/images/icn_pdf.png");
const downloadIcon = require("../../assets/images/icn_download.png");

const EachTicketPdf = ({
  eachTicket,
  onDownloadClick,
  idx,
  type = "Ticket",
}) => {
  return (
    <EachTicketPdfWrapper>
      <IconAndNameWrapper>
        <img src={pdfIcon} alt="pdf" />
        <NameAndPlaceWrapper>
          <TextFont fontColor={Colors.shark} fontSize="0.875rem">
            {type + " " + (idx + 1)}
          </TextFont>
          {/* <TextFont fontColor={Colors.brandTwo} fontSize="0.625rem">
            {eachTicket.from} to {eachTicket.to}
          </TextFont> */}
        </NameAndPlaceWrapper>
      </IconAndNameWrapper>

      <a download href={eachTicket}>
        <DownloadImg src={downloadIcon} alt="download"></DownloadImg>
      </a>
    </EachTicketPdfWrapper>
  );
};

export default EachTicketPdf;

const EachTicketPdfWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
`;

const IconAndNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
`;

const NameAndPlaceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`;

const DownloadImg = styled.img`
  cursor: pointer;
`;
